<div
  *ngIf="!fieldAttribute.hidden"
  [ngClass]="fieldAttribute.elementStyles.containerStyle"
  [attr.data-test-id]="'wrap-' + fieldAttribute.elementDataTestId"
  class="multiple-select-container"
>
  <label
    *ngIf="fieldAttribute.backendAttribute.label"
    [for]="fieldAttribute.id"
    class="form-label label"
    [ngClass]="fieldAttribute.elementStyles.labelStyle"
    (click)="$event.preventDefault()"
  >
    {{ fieldAttribute.backendAttribute.label | translate }}
    <span *ngIf="fieldAttribute.backendAttribute.required">*</span>
    <div
      *ngIf="isMobileView && isShowInfoTooltip"
      class="ms-1 custom-tooltip"
      data-test-id="info-tooltip"
      placement="left auto"
      [ngbTooltip]="organizationsProjectTooltipText || fieldAttribute.backendAttribute.placeholder | translate"
      triggers="click:blur"
    >
      <img src="assets/icons/icon-info.svg" alt="info" />
    </div>
  </label>
  <div
    [class.is-invalid]="isFieldInvalid()"
    [class.pe-5]="isFieldInvalid()"
    [class.disabled-control]="isControlDisabled()"
    [ngClass]="fieldAttribute.elementStyles.contentStyle"
    [class.fixed-height]="fieldAttribute.backendAttribute.scheme_name !== SearchFormTypes.MAP_SEARCH_BLOCK"
    [attr.data-test-id]="'container_' + fieldAttribute.elementDataTestId"
    class="d-flex flex-row flex-wrap"
  >
    <span class="btn btn-outline-secondary btn-sm selected" *ngFor="let item of selectedItems; index as i">
      <span [class]="item.organization_link_kind === 'REGISTERED' ? 'linked-btn' : 'no-linked-btn'">
        {{ item['title'] || item.organization_name | translate }}
      </span>
      <span
        [attr.data-test-id]="fieldAttribute.elementDataTestId + '-item-' + i"
        class="close-selected"
        (click)="onCloseItem(item)"
      >
        <b>x</b>
      </span>
    </span>
    <input
      appToggleOverflow
      class="multiple-search-input"
      [class.disabled-control]="isControlDisabled()"
      [class.mt-1]="selectedItems.length > 0"
      type="text"
      #multipleSearchInput
      #typehead="ngbTypeahead"
      multiple
      container="body"
      [attr.data-test-id]="fieldAttribute.elementDataTestId"
      [id]="fieldAttribute.id"
      [placeholder]="(isMobileView ? newPlaceholder : fieldAttribute.backendAttribute.placeholder) | translate"
      [ngbTypeahead]="search"
      [inputFormatter]="formatter"
      [resultFormatter]="formatter"
      (keyup)="onCheckAndSelectCustomItem($event)"
      (selectItem)="onSelectItem($event)"
      (focus)="focus$.next($event.target['value'])"
      (click)="click$.next($event.target['value'])"
      (blur)="onSelectCustomItem($event.target['value'])"
    />
  </div>
  <ng-container *ngIf="typehead && typehead.isPopupOpen()">
    <dropdown-list-pagination
      [paginationState]="paginationState$ | async"
      [isLoading]="isLoading$ | async"
      [dropdownSelector]="dropdownSelector"
      (loadMore)="onLoadMore($event)"
    ></dropdown-list-pagination>
  </ng-container>
  <small
    *ngIf="control.invalid && (control.dirty || control.touched)"
    class="d-flex mt-1 invalid-feedback"
    [attr.data-test-id]="fieldAttribute.errorDataTestId"
  >
    {{ getErrorMessage | translate }}
  </small>
</div>
